<template>
  <div>
    <v-card max-width="1000" class="mx-auto" elevation="0">
      <v-row align="center" justify="center">
        <v-overlay color="White" :absolute="absolute" :value="overlay">
          <div class="text-center">
            <v-progress-circular
              :size="70"
              :width="7"
              color="blue"
              indeterminate
            ></v-progress-circular>
          </div>
        </v-overlay>
      </v-row>
      <br />
      <br />
      <v-subheader>Delivery Destination</v-subheader>
      <div>
        <v-card flat>
          <v-container>
            <v-form ref="form" lazy-validation>
              <v-text-field
                label="Name"
                v-model="name_order"
                required
                :rules="name_orderRules"
                append-icon="mdi-user"
              ></v-text-field>

              <v-textarea
                label="Address"
                v-model="address"
                required
                :rules="addressRules"
                auto-grow
                rows="3"
              ></v-textarea>

              <v-text-field
                label="Phone"
                v-model="phone"
                :rules="phoneRules"
                required
                append-icon="mdi-phone"
              ></v-text-field>

              <v-select
                v-model="province_id"
                :items="provinces"
                item-text="province"
                item-value="province_id"
                label="Province"
                persistent-hint
                single-line
                required
                :rules="province_idRules"
              ></v-select>

              <v-select
                v-model="city_id"
                v-if="province_id > 0"
                :items="citiesByProvince"
                item-text="city_name"
                item-value="city_id"
                label="City"
                persistent-hint
                single-line
                required
                :rules="city_idRules"
              ></v-select>

              <v-select
                v-model="subdistrict_id"
                v-if="city_id > 0"
                :items="subdistrictByCities"
                item-text="subdistrict_name"
                item-value="subdistrict_id"
                label="Kecamatan"
                persistent-hint
                single-line
                required
                :rules="subdistrict_idRules"
              ></v-select>
            </v-form>
            <v-card-actions>
              <v-btn
                color="#1B5E20"
                dark
                @click="saveShipping"
                :disabled="isSaveDisabled"
              >
                <v-icon>mdi-content-save</v-icon> &nbsp; Save
              </v-btn>
            </v-card-actions>
          </v-container>
        </v-card>
        <v-card-text>
          <center>
            <v-btn
              @click="checkout"
              :disabled="isSaveDisabled"
              rounded
              color="#1B5E20"
              outlined
              elevation="5"
              large
            >
              <v-icon>mdi-truck-delivery</v-icon> &nbsp; Select Delivery Service
            </v-btn>
          </center>
        </v-card-text>
        <br />
      </div>
      <template>
        <v-layout row justify-center>
          <v-dialog
            v-model="dialogProsesed"
            persistent
            max-width="290"
            id="dialogProsesed"
          >
            <v-progress-linear indeterminate color="blue" height="30"
              ><span>Waits...</span></v-progress-linear
            >
          </v-dialog>
        </v-layout>
      </template>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      name_order: "",
      address: "",
      phone: "",
      province_id: 0,
      city_id: 0,
      subdistrict_id: 0,
      absolute: true,
      overlay: false,

      subdistrict_idRules: [(v) => !!v || "subdistrict is required"],
      city_idRules: [(v) => !!v || "city is required"],
      province_idRules: [(v) => !!v || "province is required"],
      phoneRules: [(v) => !!v || "phone is required"],
      addressRules: [(v) => !!v || "address is required"],
      name_orderRules: [(v) => !!v || "name is required"],
      dialogProsesed: false,
    };
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
      provinces: "region/provinces",
      cities: "region/cities",
      subdistrict: "region/subdistrict",
      totalQuantity: "cart/totalQuantity",
    }),
    citiesByProvince() {
      let province_id = this.province_id;
      this.selectSubdistrict();
      return this.cities.filter((city) => {
        if (city.province_id == province_id) {
          return city;
        }
      });
    },
    subdistrictByCities() {
      let city_id = this.city_id;
      return this.subdistrict.filter((subdistrict) => {
        if (subdistrict.city_id == city_id) return subdistrict;
      });
    },

    isSaveDisabled() {
      return (
        this.totalQuantity == 0 ||
        this.name_order === "" ||
        this.address === "" ||
        this.phone === "" ||
        this.province_id == 0 ||
        this.city_id == 0 ||
        this.subdistrict_id == 0
      );
    },
  },
  methods: {
    ...mapActions({
      setAlert: "alert/set",
      setAuth: "auth/set",
      setProvinces: "region/setProvinces",
      setCities: "region/setCities",
      setSubdistrict: "region/setSubdistrict",
    }),
    selectSubdistrict() {
      if (this.city_id != 0) {
        let city_id = this.city_id;
        this.axios.get("/subdistrict?cities_id=" + parseInt(city_id)).then((response) => {
          let { data } = response.data;
          this.setSubdistrict(data);
        });
      }
    },

    saveShipping() {
      if (this.$refs.form.validate()) {
        this.overlay = true;
        let formData = new FormData();
        formData.set("name_order", this.name_order);
        formData.set("address", this.address);
        formData.set("phone", this.phone);
        formData.set("province_id", this.province_id);
        formData.set("city_id", this.city_id);
        formData.set("subdistrict_id", this.subdistrict_id);
        if (this.subdistrict_id == null) {
          this.setAlert({
            status: true,
            text: "Subdistrict ​​must be selected",
            color: "warning",
          });
        }
        if (this.city_id == null) {
          this.setAlert({
            status: true,
            text: "City ​​must be selected",
            color: "warning",
          });
        }
        let config = {
          headers: {
            Authorization: "Bearer " + this.user.api_token,
          },
        };

        this.axios
          .post("/shipping", formData, config)
          .then((response) => {
            let { data } = response;
            this.setAuth(data.data);
            this.setAlert({
              status: true,
              text: data.message,
              color: "success",
            });
            this.overlay = false;
          })
          .catch((error) => {
            this.overlay = false;
            let { data } = error;
            this.setAlert({
              status: true,
              text: data.message,
              color: "error",
            });
          });
      }
    },
    checkout() {
      if (
        this.totalQuantity == 0 ||
        this.name_order == "" ||
        this.address == "" ||
        this.phone == "" ||
        this.province_id == 0 ||
        this.city_id == 0 ||
        this.subdistrict_id == 0
      ) {
        this.setAlert({
          status: true,
          text: "Mohon lengkapi Delivery Destination",
          color: "warning",
        });
      } else {
        if (this.$refs.form.validate()) {
          this.close();
          this.$router.push({
            path: "/checkout",
          });
        }
      }
    },
    close() {
      this.$emit("closed", false);
    },
  },

  created() {
    this.name_order = this.user.name_order;
    this.address = this.user.address;
    this.phone = this.user.phone;
    this.subdistrict_id = this.user.subdistrict_id;
    this.city_id = this.user.city_id;
    this.province_id = this.user.province_id;

    if (this.provinces && this.provinces.length == 0) {
      this.axios.get("/provinces").then((response) => {
        let { data } = response.data;
        this.setProvinces(data);
      });

      this.axios.get("/cities").then((response) => {
        let { data } = response.data;
        this.setCities(data);
      });

      this.axios.get("/subdistrict").then((response) => {
        let { data } = response.data;
        this.setSubdistrict(data);
      });
    }
  },
};
</script>

<style scoped>
.v-progress-circular {
  margin: 1rem;
}
</style>
